// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".luZHGq8qAiaPmd01_IOz{display:block;width:min-content}", "",{"version":3,"sources":["webpack://./src/App/components/EntityLibrary/EntitySortMenu.module.scss"],"names":[],"mappings":"AAEA,sBACE,aAAA,CACA,iBAAA","sourcesContent":["@import \"App/styles/_variables\";\n\n.highnote-entity-sort-select {\n  display: block;\n  width: min-content;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"highnote-entity-sort-select": "luZHGq8qAiaPmd01_IOz"
};
export default ___CSS_LOADER_EXPORT___;
